<template>
  <div>
    <b-modal
      v-if="!modaladd"
      id="modal-ajout"
      hide-footer
      centered
      title=" Ajouter Client"
      style="position:relative;"
    >
      <GStockLoader :loading="loading" />
      <form @submit="formSubmit">
        <div class="pl-lg-4">
          <div class="row">
            <div class="col-lg-12">
              <b-form-group
                id="input-group-1"
                label="Nom et Prénom"
                label-for="input-1"
              >
                <b-form-input
                  label="Nom et Prénom"
                  placeholder="Nom et Prénom"
                  input-classes="form-control-alternative"
                  v-model="model.fullname"
                  required
                />
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group
                id="input-group-1"
                label="Numero Tel"
                label-for="input-1"
              >
                <b-form-input
                  type="number"
                  label="Numero Tel"
                  placeholder="Numero"
                  input-classes="form-control-alternative"
                  v-model="model.phonenumber"
                  required
                />
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group
                id="input-group-1"
                label="Adresse e-mail"
                label-for="input-1"
              >
                <b-form-input
                  type="email"
                  label="Adresse e-mail"
                  placeholder="Adresse e-mail"
                  input-classes="form-control-alternative"
                  v-model="model.email"
                />
              </b-form-group>
            </div>
          </div>
          <!--  <div class="row">
       
          </div>-->
        </div>

        <hr class="my-4" />
        <!-- Description -->
        <center>
          <b-btn
            type="submit"
            style="background-color:#000; width: 150px; height:50px;color:#fff"
            >Ajouter</b-btn
          >
        </center>
      </form>
    </b-modal>
  </div>
</template>
<script>
import GStockLoader from "@/components/Loader";
import { setToken, post } from "@/mixins/api";

export default {
  name: "ModalAjoutClient",
  components: {
    GStockLoader,
  },
  data() {
    return {
      modaladd: false,
      model: {
        fullname: "",
        phonenumber: "",
        email: ''
      },
      currentPage: 1,
      standAlonePages: {},
      canLoadMore: true,
      userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk",
      loading: false,
    };
  },

  methods: {
    formSubmit(e) {
      e.preventDefault();
      //let currentObj = this;
      this.loading = true;
      post("client", this.model)
        .then((resp) => {
          this.data = resp.data.data;
          this.$emit("clientsadd", this.data, (this.modaladd = false));
          this.modaladd = true;
        })
        .finally(() => {
          this.loading = false;
        });

      e.target.reset();
    },
  },
  mounted() {
    setToken(this.userToken);
  },
};
</script>
